module.exports = __webpack_public_path__ + "static/media/change_w.a7df14c4.svg";